import { render } from "./toastNotification.vue?vue&type=template&id=08d42d97"
import script from "./toastNotification.vue?vue&type=script&lang=js"
export * from "./toastNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__